import { Helmet } from 'react-helmet-async';
import { useState, useMemo, useRef } from 'react';
// @mui
import {
  Card,
  Container,
  Stack,
  Button,
  Box,
  TextField,
  MenuItem
} from '@mui/material';
import MUIDataTable from "mui-datatables";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { id } from "date-fns/locale";
import { endOfDay } from 'date-fns';
import MonitoringNominalFooter from '../../../components/table/MonitoringNominalFooter';
import { TableLoader } from '../../../components/table';
import { getCurrentDate } from "../../../utils/formatDate";
// Context
import { axiosPrivate } from '../../../common/axiosPrivate';

export default function LaporanPenagihanPetugasPage() {
  const startDateRef = useRef(null);
  const endDateRef = useRef(null);
  const [data, setData] = useState([]);
  const [produk, setProduk] = useState('semua');
  const [tableLoading, setTableLoading] = useState(false);

  const BodyComponent = useMemo(
    () => (props) => (
      <TableLoader loading={tableLoading} {...props} />
    ),
    [tableLoading]
  );

  const columns = [
    {
      name: "number",
      label: "No",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => Number(tableMeta.rowIndex) + 1
      }
    },
    { name: "kantor", label: "Kantor", options: { filter: true, sort: true } },
    { name: "kodePegawai", label: "Kode Pegawai", options: { filter: false, sort: true } },
    { name: "nama", label: "Petugas", options: { filter: true, sort: true } },
    { name: "namaJabatan", label: "Jabatan", options: { filter: true, sort: true } },
    { name: "totalRumpun", label: "Total Rumpun", options: { filter: false, sort: true } },
    { name: "totalAnggota", label: "Total Anggota", options: { filter: false, sort: true } },
    { name: "tertagih", label: "Tertagih", options: { filter: false, sort: true } },
    { name: "tidakTertagih", label: "Tidak Tertagih", options: { filter: false, sort: true } },
    {
      name: "penerimaanTunai",
      label: "Tunai",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (Number(value) || 0).toLocaleString('id-ID')
      }
    },
    {
      name: "penerimaanTransfer",
      label: "Transfer",
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value) => (Number(value) || 0).toLocaleString('id-ID')
      }
    },
    {
      name: "totalPenerimaan",
      label: "Total Penerimaan",
      options: {
        display: true,
        viewColumns: false,
        filter: false,
        sort: true,
        customBodyRender: (value) => (Number(value) || 0).toLocaleString('id-ID')
      }
    }
  ];

  const options = {
    filterType: "dropdown",
    selectableRowsHideCheckboxes: true,
    customTableBodyFooterRender: ({ data: displayData, columns: tableColumns }) => (
      <MonitoringNominalFooter
        displayData={displayData}
        rows={data}
        columns={tableColumns}
        amountField="totalPenerimaan"
        label="Total Keseluruhan Penerimaan"
      />
    ),
    downloadOptions: {
      filename: `Pengihan-By-Petugas-${getCurrentDate('-')}.csv`,
      filterOptions: {
        useDisplayedColumnsOnly: false,
        useDisplayedRowsOnly: true,
      }
    },
  };
  
  const handleStartDateChange = (date) => {
    startDateRef.current = date;
  };

  const handleEndDateChange = (date) => {
    endDateRef.current = date;
  };

  const filterData = () => {
    setTableLoading(true);

    const modEndDate = endOfDay(endDateRef.current);

    axiosPrivate.post(`/laporan/monitoring-penagihan-by-petugas`, {startDate: startDateRef.current, endDate: modEndDate, produk})
    .then((response) => {
      const data = response?.data;
      
      setData(data);
    })
    .catch((error) => console.log(error))
    .finally(() => setTableLoading(false));
  }

  return (
    <>
      <Helmet>
        <title> Rekap Absensi Penagihan By Petugas | Sip App </title>
      </Helmet>
      <Container
        sx={{
          mt: 5
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            mb: 2
          }}
        >
          <Stack direction="row" alignItems="center" justifyContent="start" sx={{ flexWrap: 'wrap', rowGap: 2 }}>
            <Box sx={{ marginRight: 2 }}>
              <LocalizationProvider adapterLocale={id} dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="Dari Tanggal"
                  value={startDateRef.current}
                  onChange={handleStartDateChange}
                  slotProps={{ textField: { size: 'small' } }}
                />
              </LocalizationProvider>
            </Box>

            <Box sx={{ marginRight: 2 }}>
              <LocalizationProvider adapterLocale={id} dateAdapter={AdapterDateFns}>
                <DatePicker
                  label="Sampai Tanggal"
                  value={endDateRef.current}
                  onChange={handleEndDateChange}
                  slotProps={{ textField: { size: 'small' } }}
                />
              </LocalizationProvider>
            </Box>

            <TextField
              select
              label="Produk"
              size="small"
              value={produk}
              onChange={(event) => setProduk(event.target.value)}
              sx={{ minWidth: 150, mr: 2 }}
            >
              <MenuItem value="semua">Semua</MenuItem>
              <MenuItem value="UMP">UMP</MenuItem>
              <MenuItem value="UMIHA">UMIHA</MenuItem>
            </TextField>

            <Button variant="contained" onClick={filterData}>
              Filter
            </Button>
          </Stack>
        </Box>
        <Card>
          <MUIDataTable
            title="Rekap Absensi Penagihan By Petugas"
            data={data}
            columns={columns}
            options={options}
            components={{ TableBody: BodyComponent }}
          />
        </Card>
      </Container>
    </>
  );
}
